export const addTokenToUrl = ({ url, authToken }) =>
  authToken ? `${url}?token=${authToken}` : url;
